export const contextPath = (path) => {
  return String(path).replace(/\/{1,2}$/, "").replace(/\/{2,3}/g, "/");
};

export const contextMatchPath = (path) => {
  // make shure the path ends with "somePath/:id"
  return contextPath(path).replace(/\/{0,2}$/, "/:id");
};
